import React, { useState, useRef, useEffect } from 'react';

export default function NumberEditor({ value, column, onSave, onCancel }) {
  const [val, setVal] = useState(value !== '' && value !== null ? value : '');
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') onSave(val);
    if (e.key === 'Escape') onCancel();
  };

  return (
    <>
      <input
        ref={inputRef}
        type="number"
        step="any"
        className="cm-number-input"
        value={val}
        onChange={e => setVal(e.target.value)}
        onWheel={e => e.currentTarget.blur()}
        onKeyDown={handleKeyDown}
      />
      <button className="cm-cell-edit-btn cm-cell-edit-btn--save" onClick={() => onSave(val)}>
        <i className="fas fa-check" />
      </button>
      <button className="cm-cell-edit-btn cm-cell-edit-btn--cancel" onClick={onCancel}>
        <i className="fas fa-times" />
      </button>
    </>
  );
}
